module.exports = __webpack_public_path__ + "img/user8.31c1c75b.png";